// Module
var code = "<div>\n  <section class=\"heading\">\n    <div class=\"row no-gutter\">\n      <ng-include src=\"'/dashboard/nav.html'\"></ng-include>\n    </div>\n  </section>\n\n  <orders-dashboard current-user=\"currentUser\" on-error=\"onError\" />\n</div>\n";
// Exports
var _module_exports = code;;
var path = '/dashboard/orders.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;